import React from "react";
import "./Srinath_Kalavichirattil.css";

const Srinath_Kalavichirattil = () => (

  <div className='Srinath_KalavichirattilMain'>
  <a href={"https://www.linkedin.com/in/srinathk/"} target={"_blank"}><h3 className="text-center" >Srinath Kalavichirattil</h3></a>

<p>I have worked with Charles for more than 2 years - for a short period 
    on the ViP211z project and mostly on SAGE.</p>

<p>In this time Charles has proven to be an enthusiastic team player 
    and brings a lot of technical expertise to the team.</p>

<p>On the ViP211z project, one of his major contributions was the 
    implementation of the backtrace functionality. This gave developers 
    the ability to investigate crashes much faster and much easier than 
    before. Charles has a reputation of being able to debug and fix bugs 
    that are hard to create and characterize.</p>

<p>On the SAGE project, Charles designed, developed and maintained the 
    time manager module. He worked closely with me and the architects 
    to ensure it was developed the right way. He brought forth several 
    good design ideas. He also patched the busybox opensource package 
    to add functionality that was specific to the SAGE. He was instrumental 
    in implementing the timezone support and worked with the UI team to 
    integrate and test.</p>

<p>He actively participated in Plugfest to study the HDMI compatibility 
    of SAGE with various audio/video sources and sinks. He documented 
    the issues observed so we could investigate them. Charles also 
    implemented tools that developers needed to flash software on the SAGE.</p>

<p>Charles has the ability to get to the minute details of his tasks and 
    this helps to get things done the right way.</p>

<p>He has been a valuable member of my team and has a great sense of humor.</p>

<p>I will be more than happy to work with him in the future.</p>


  </div>
);

export default Srinath_Kalavichirattil;


// WEBPACK FOOTER //
// ./src/components/AboutMe/Srinath_Kalavichirattil.js